* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.list-title {
  color: var(--chart-302-icon-buttons-titles);
  min-height: calc(4 * var(--spacer));
  display: flex;
  align-items: center;
  margin-bottom: var(--spacer);
  border-bottom: 1px solid var(--grey-layout-chart-100);
}

.content {
  display: flex;
  flex-direction: row;
  max-width: 1056px;
  min-width: 1056px;
  height: 100%;
  column-gap: calc(2 * var(--spacer));
  justify-content: center;
  max-height: 665px;
  min-height: 320px;

  .column {
    flex-grow: 1;
    flex-basis: 0;
    width: 252px;
  }
}

.selection-summary {
  font-family: var(--font-family-secondary);
  color: var(--body-text-arrows-400);
  .emphasized {
    color: var(--blue-layout-400-primary);
  }
}
